import { useEffect, useRef } from "react";
import { writeDictationVault } from "../utils/dictationVault";

/**
 * Never-lose-text flushes: pagehide / visibility hidden / beforeunload.
 * Call from every surface that holds unsaved user prose.
 */
export function useNeverLoseText({
  enabled = true,
  text,
  source = "editor",
  minChars = 8,
}) {
  const textRef = useRef(text);
  textRef.current = text;

  useEffect(() => {
    if (!enabled) return undefined;

    const flush = () => {
      const raw = String(textRef.current || "");
      if (raw.trim().length < minChars) return;
      writeDictationVault(raw, { source: `${source}-flush` });
    };

    const onVis = () => {
      if (document.visibilityState === "hidden") flush();
    };
    const onUnload = (e) => {
      flush();
      const raw = String(textRef.current || "").trim();
      if (raw.length < minChars) return;
      e.preventDefault();
      e.returnValue = "";
    };

    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("pagehide", flush);
    window.addEventListener("beforeunload", onUnload);
    return () => {
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("pagehide", flush);
      window.removeEventListener("beforeunload", onUnload);
    };
  }, [enabled, minChars, source]);
}
